module.exports = __webpack_public_path__ + "img/sort-up__active.c7409409.png";